import { render, staticRenderFns } from "./ProductService.vue?vue&type=template&id=63ef79f3&scoped=true&"
import script from "./ProductService.vue?vue&type=script&lang=js&"
export * from "./ProductService.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ProductService-pc.css?vue&type=style&index=0&id=63ef79f3&scoped=true&lang=css&"
import style1 from "../assets/css/ProductService-phone.css?vue&type=style&index=1&id=63ef79f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef79f3",
  null
  
)

export default component.exports